module.exports = __webpack_public_path__ + "media/images/pic/saska/languages_companies_saska_background-bb2366ee992f3f537d5be15ba3e31dac.svg";